import { PATH_ROOT } from "@/constants";
import PageHeader from "../../PageHeader";

import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { BreadcrumbItem } from "@/types/breadcrumb";

interface QueryTableHeaderProps {
  actions?: React.ReactNode[];
  breadcrumbs?: BreadcrumbItem[];
  breadcrumbLabel?: string;
}

export const QueryTableHeader = memo(
  ({ actions, breadcrumbs, breadcrumbLabel }: QueryTableHeaderProps) => {
    const { t } = useTranslation();
    const breadcrumbItems = useMemo(() => {
      if (breadcrumbs) {
        return breadcrumbs;
      }
      return [
        { label: t("breadcrumb.home"), href: PATH_ROOT },
        ...(breadcrumbLabel ? [{ label: t(breadcrumbLabel) }] : []),
      ];
    }, [breadcrumbLabel, breadcrumbs, t]);

    return <PageHeader breadcrumbItems={breadcrumbItems} actions={actions} />;
  },
);
